<ng-container *ngIf="!overriddenHeaderName">
    <div class="grid-group-header" *ngFor="let option of group.options; first as first" [class.grid-group-attribute]="first && group.marketAttribute">
        {{ option }}
    </div>
</ng-container>
<div class="grid-group-header" *ngIf="overriddenHeaderName">
    {{ overriddenHeaderName }}
</div>
